// DelMenu.js
// Holding all the buttons for the DELs.

import React from "react";
import { useAppStore } from "../../../../store/appStore";
import styles from "./DelMenu.module.css";

const DelMenuOptions = ({ activeTab, isDelMenuExpanded, onTabClick }) => {
  const toggleDelMenu = useAppStore((s) => s.mainMenuActions.toggleDelMenu);

  // Function to handle submenu option clicks
  const handleSubmenuClick = (tabName) => {
    onTabClick(tabName);

    // Close the submenu on mobile and tablet screens
    if (window.innerWidth < 1024) {
      toggleDelMenu();
    }
  };

  return (
    <div
      className={`${styles.delMenuContainer} ${
        isDelMenuExpanded ? styles.expanded : ""
      }`}
      data-testid="del-menu-options"
    >
      {/* My Drafts */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "drafts" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("drafts")}
        data-testid="drafts-tab"
      >
        My Drafts
      </button>

      {/* My Submitted */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "submitted" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("submitted")}
        data-testid="submitted-tab"
      >
        My Submits
      </button>

      {/* Approvals */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "approvals" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("approvals")}
        data-testid="approvals-tab"
      >
        My Approvals
      </button>

      {/* Reporting (desktop only) */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "del_reporting" ? styles.active : ""
        } ${styles.desktopOnly}`}
        onClick={() => handleSubmenuClick("del_reporting")}
        data-testid="del_reporting-tab"
      >
        All DELs
      </button>
    </div>
  );
};

export const DelMenu = ({
  activeTab,
  isDelMenuExpanded,
  mainMenuStyles,
  handleMainMenuButtonClick,
  onTabClick,
}) => {
  // Check if any DEL tab is active
  const isAnyDelTabActive =
    activeTab === "drafts" ||
    activeTab === "submitted" ||
    activeTab === "approvals" ||
    activeTab === "del_reporting";

  return (
    <>
      <button
        className={`${mainMenuStyles.tabButton} ${styles.delButton} ${
          isAnyDelTabActive ? styles.active : ""
        }`}
        onClick={() => handleMainMenuButtonClick("del")}
        data-testid="del-menu-button"
      >
        DELs {isDelMenuExpanded ? "▼" : "▶"}
      </button>
      <DelMenuOptions
        activeTab={activeTab}
        isDelMenuExpanded={isDelMenuExpanded}
        onTabClick={onTabClick}
      />
    </>
  );
};
